export default "/static/media/1345516b6ac3e5ca9a8f0fab0a158379.png";